import React from 'react';
import { Link as StyleguideLink } from 'styleguide';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import { BuiltInComponents } from 'craft/constants';
import { Resolver } from 'craft/types';

export const Link: Resolver = ({ children }: any) => {
  const className = toCssSelector('link', {
    variant: { variant: 'base' },
    output: 'html',
  });

  return (
    <StyleguideLink
      className={className}
      href="#"
      onClick={(e: Event) => {
        e.preventDefault();
      }}
    >
      {children}
    </StyleguideLink>
  );
};

Link.craft = {
  name: BuiltInComponents.Link,
};

Link.slate = {
  toCraftNode: (slateNode: any) => (craftNode: any) => {
    // eslint-disable-next-line
    craftNode.data.props.href = slateNode.data?.props?.href;
    // eslint-disable-next-line
    craftNode.data.custom.variables = slateNode.data?.custom?.variables;
  },
  toSlateNode: (craftNode: any) => (slateNode: any) => {
    // eslint-disable-next-line
    slateNode.data = {
      props: {
        href: craftNode?.data?.props?.href,
      },
      custom: {
        variables: craftNode?.data?.custom?.variables,
      },
    };
  },
};
